import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import type { RoleDefinition } from '../../types';

const ROLE_TONE: Record<string, string> = {
  full_admin: 'bg-purple-100 text-purple-800 border-purple-300',
  director: 'bg-indigo-100 text-indigo-800 border-indigo-300',
  sales_manager: 'bg-blue-100 text-blue-800 border-blue-300',
  operations_manager: 'bg-green-100 text-green-800 border-green-300',
  quality_manager: 'bg-amber-100 text-amber-800 border-amber-300',
  csm: 'bg-teal-100 text-teal-800 border-teal-300',
};

interface Props {
  role: string;
  definition?: RoleDefinition;
  size?: 'sm' | 'md';
}

export function RoleChip({ role, definition, size = 'sm' }: Props) {
  const label = definition?.label ?? role;
  const tone = ROLE_TONE[role] ?? 'bg-slate-100 text-slate-700 border-slate-300';

  const chip = (
    <span
      className={cn(
        'inline-flex items-center rounded-full border font-medium',
        size === 'sm' ? 'text-[10px] px-2 py-0.5' : 'text-xs px-2.5 py-1',
        tone,
      )}
    >
      {label}
    </span>
  );

  if (!definition?.description) return chip;

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>{chip}</TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs text-xs">
          {definition.description}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
